/*
 * @Author: lzz
 * @Date: 2024-02-27 20:31:20
 * @LastEditTime: 2024-09-02 20:10:31
 */
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
var router = new Router({
	routes: [
		{
			path: '/',
			name: 'index',
			component: () => import('@/views/index.vue'), // 首页
		},
		{
			path: '/home',
			name: 'home',
			component: () => import('@/views/index.vue'), // 首页
		}, {
			path: '/index',
			name: 'socialLogin',
			component: () => import('@/views/socialLogin.vue')
		}, {
			path: "/departCase",
			name: 'departCase',
			component: () => import('@/views/departCase/index.vue')
		}, {//党群
			path: "/partyBuild",
			name: 'partyBuild',
			component: () => import('@/views/partyBuild/index.vue')
		}, {//部门落地培训
			path: "/departLand",
			name: 'departLand',
			component: () => import('@/views/departLand/index.vue')
		}, {
			path: "/departCaseDetails",
			name: 'departCaseDetails',
			component: () => import('@/views/departCase/details.vue')
		}, {
			path: "/partyBuildDetails",
			name: 'partyBuildDetails',
			component: () => import('@/views/partyBuild/details.vue')
		}, {
			path: "/msgDetails",
			name: 'msgDetails',
			component: () => import('@/components/msgDetails.vue')
		}, {
			path: "/departLandDetails",
			name: 'departLandDetails',
			component: () => import('@/views/departLand/details.vue')
		}, {
			path: "/personCenter",
			name: 'personCenter',
			component: () => import('@/views/personCenter/index.vue')
		}, {
			path: "/tinyLesson",
			name: 'tinyLesson',
			component: () => import('@/views/tinyLesson/index.vue')
		}, {
			path: "/selfEvaluate",
			name: 'selfEvaluate',
			component: () => import('@/views/selfEvaluate/index.vue')
		}, {
			path: "/exam",
			name: 'exam',
			component: () => import('@/views/exam/index.vue')
		},
		{
			path: "/lessonDetails",
			name: 'lessonDetails',
			component: () => import('@/views/tinyLesson/details.vue')
		}, {
			path: "/personCenter/:type",
			name: 'personCenter',
			component: () => import('@/views/personCenter/index.vue')
		},
		// 步骤-承诺
		{
			path: "/promise",
			name: 'promise',
			component: () => import('@/views/promise/promise.vue')
		},
		// 步骤-证书
		{
			path: "/certificate",
			name: 'certificate',
			component: () => import('@/views/promise/certificate.vue')
		},

		// 主题下载
		{
			path: "/subjectDown",
			name: 'subjectDown',
			component: () => import('@/views/subjectDown/index.vue')
		},
		// 我的互动
		{
			path: "/myInteraction",
			name: 'myInteraction',
			component: () => import('@/views/personCenter/myInteraction.vue')
		},
		// 我的互动
		{
			path: "/finishLesson",
			name: 'finishLesson',
			component: () => import('@/views/personCenter/finishLesson.vue')
		},
		// 我的互动
		{
			path: "/unfinishLesson",
			name: 'unfinishLesson',
			component: () => import('@/views/personCenter/unfinishLesson.vue')
		},
		// 我的考试
		{
			path: "/myExam",
			name: 'myExam',
			component: () => import('@/views/personCenter/myExam.vue')
		},
		// 我的承诺
		{
			path: "/myPromise",
			name: 'myPromise',
			component: () => import('@/views/personCenter/myPromise.vue')
		},
		// 我的证书
		{
			path: "/myCert",
			name: 'myCert',
			component: () => import('@/views/personCenter/myCert.vue')
		},
		// 我的自评
		{
			path: "/mySelfEvaluate",
			name: 'mySelfEvaluate',
			component: () => import('@/views/personCenter/mySelfEvaluate.vue')
		},
		//高管寄语
		{
			path: "/executiveMessage",
			name: 'executiveMessage',
			component: () => import('@/views/executiveMessage/index.vue')
		},
		{
			path: "/social-login",
			name: 'socialLogin',
			component: () => import('@/views/socialLogin.vue')
		},
		{
			path: "/forLogin",
			name: 'forLogin',
			component: () => import('@/views/forLogin.vue')
		},
	]
});
//防止路由重复加载报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
// router.beforeEach((to, from, next) => {
// 	// 当页面刷新时，to 和 from 的值都是 undefined，
// 	// 所以判断如果两者都为undefined，则重定向到首页
// 	console.log(from.name ,to.name)
// 	if (!from.name && to.name !='index' && to.name !='socialLogin' && to.name !='forLogin') {
// 	  next({ name: '/home' });
// 	} else {
// 	  next();
// 	}
//   });
// router.onError((error) => {
//     const jsPattern = /Loading chunk (\S)+ failed/g
//     const cssPattern = /Loading CSS chunk (\S)+ failed/g
//     const isChunkLoadFailed = error.message.match(jsPattern || cssPattern)
//     const targetPath = router.history.pending.fullPath
//     if (isChunkLoadFailed) {
//         localStorage.setItem('targetPath', targetPath)
//         window.location.reload()
//     }
// })
// router.onReady(() => {
//     const targetPath = localStorage.getItem('targetPath')
//     const tryReload = localStorage.getItem('tryReload')
//     if (targetPath) {
//         localStorage.removeItem('targetPath')
//         if (!tryReload) {
//             router.replace(targetPath)
//             localStorage.setItem('tryReload', true)
//         } else {
//             localStorage.removeItem('tryReload')
//         }
//     }
// })
export default router;